import script from "./UserDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserDetail.vue?vue&type=script&lang=ts&setup=true"

import "./UserDetail.vue?vue&type=style&index=0&id=2400b2fe&lang=scss"

const __exports__ = script;

export default __exports__